import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

// Opened from the invite link: /nurse/set-password?token=...
// Route:  <Route path="/nurse/set-password" element={<NurseSetPassword />} />
const NurseSetPassword = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [who, setWho] = useState(null); // { name, email }
  const [linkError, setLinkError] = useState(null);
  const [checking, setChecking] = useState(true);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) {
      setLinkError('This link is not valid. Ask for a new one.');
      setChecking(false);
      return;
    }
    axios
      .get(`${config.baseURL}/api/nurse-auth/invite/${encodeURIComponent(token)}`)
      .then((r) => setWho(r.data.data))
      .catch((e) => setLinkError(e.response?.data?.error || 'This link is not valid. Ask for a new one.'))
      .finally(() => setChecking(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password.length < 8) return setError('Password must be at least 8 characters');
    if (password !== confirm) return setError('The two passwords do not match');

    setSaving(true);
    try {
      await axios.post(`${config.baseURL}/api/nurse-auth/accept-invite`, { token, password });
      await Swal.fire({ title: 'Password set', text: 'You can now sign in.', icon: 'success', showConfirmButton: false, timer: 1800 });
      navigate('/doctor/login', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Could not set the password. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
    <Header/>
    <section className="login-part doctor-login-part">
      <div className="container">
        <div className="row" style={{ justifyContent: 'center' }}>
          <div className="col-md-6">
            <div className="login-box">
              <div className="login-title">Set your password</div>

              {checking ? (
                <p style={{ color: '#888', fontSize: 14 }}>Checking your link…</p>
              ) : linkError ? (
                <div>
                  <p style={{ color: '#B42318', marginBottom: 16, fontSize: 14 }}>{linkError}</p>
                  <button type="button" onClick={() => navigate('/doctor/login')}>BACK TO LOGIN</button>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <p style={{ color: '#888', marginBottom: 20, fontSize: 14 }}>
                    Welcome, {who?.name}. Choose a password for {who?.email}.
                  </p>

                  <div className="form-group password-box">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="New password (at least 8 characters)"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="new-password"
                    />
                    <span className="toggle-eye" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                      {showPassword ? '👁️' : '👁️‍🗨️'}
                    </span>
                  </div>

                  <div className="form-group password-box">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Confirm password"
                      value={confirm}
                      onChange={(e) => setConfirm(e.target.value)}
                      autoComplete="new-password"
                    />
                  </div>

                  {error && (
                    <div className="invalid-feedback" style={{ display: 'block', marginBottom: 10 }}>{error}</div>
                  )}

                  <button type="submit" disabled={saving}>{saving ? 'SAVING...' : 'SET PASSWORD'}</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer/>
    </>
  );
};

export default NurseSetPassword;